module.exports = __webpack_public_path__ + "adb067c51f3a786d5cd68b48a5ee2aab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/trenchcoat-s.png
// module id = 1956
// module chunks = 0